export default __webpack_public_path__ + "static/media/logo-blog.d722e47d.png";